module.exports = {
      id: "environment-usage",
      viewBox: "0 0 28.781 28.787",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#environment",
      toString: function () {
        return this.url;
      }
    }